import "./Guide.module.css";
import Header from "@/reusable_sections/Header";
import Guide from "./sections/Guide";
import Distinction from "./sections/Distinction";
import GuidePhases from "./sections/GuidePhases";
import Trust from "./sections/Trust";
import Closingcta from "./sections/Closingcta";
import Footer from "@/reusable_sections/Footer";
import Preview from "./sections/Preview";
import CustomerReviews from "./sections/CustomerReviews";
export default function GuidePage() {
  return <div>
      <Header />
      <Guide />
      <Distinction />
      <GuidePhases />
      <Preview />
      <Trust />
      <CustomerReviews />
      <Closingcta />
      <Footer />
    </div>;
}